import Transform from '@ember-data/serializer/transform';
export default class CatalogObjectReference extends Transform {
  deserialize(serialized) {
    return {
      catalogVersion: serialized.catalog_version,
      objectId: serialized.object_id
    };
  }
  serialize(deserialized) {
    return {
      catalog_version: deserialized.catalogVersion,
      object_id: deserialized.objectId
    };
  }
}